function roleValidator (profile) {
  const validRoles = ['Administrator', 'TroodyProjectManager', 'TroodyCaseBuilder', 'TroodyBroker', 'TroodyGroup']
  const roles = (profile || {}).role
  let valid = (roles !== undefined && roles !== null)

  if (valid) {
    if (Array.isArray(roles)) {
      valid = false
      for (var roleIndex = 0; roleIndex < roles.length; roleIndex++) {
        if (validRoles.indexOf(roles[roleIndex]) > -1) {
          valid = true
          break
        }
      }
    } else {
      valid = validRoles.indexOf(roles) > -1
    }
  }

  return valid
}

function isRole (profile, candidateRole) {
  let valid = false
  const roles = (profile || {}).role

  if (Array.isArray(roles)) {
    for (var roleIndex = 0; roleIndex < roles.length; roleIndex++) {
      if (roles[roleIndex] === candidateRole) {
        valid = true
        break
      }
    }
  } else {
    valid = (roles === candidateRole)
  }

  return valid
}

function isGroup (profile) {
  return (isRole(profile, 'TroodyGroup') || isBroker(profile))
}

function isBroker (profile) {
  return (isRole(profile, 'TroodyBroker') || isCaseBuilder(profile))
}

function isCaseBuilder (profile) {
  return (isRole(profile, 'TroodyCaseBuilder') || isProjectManager(profile))
}

function isProjectManager (profile) {
  return (isRole(profile, 'TroodyProjectManager') || isAdmin(profile))
}

function isAdmin (profile) {
  return isRole(profile, 'Administrator')
}

function isDemo (profile) {
  return isRole(profile, 'Demo')
}

export { roleValidator, isRole, isGroup, isBroker, isCaseBuilder, isProjectManager, isAdmin, isDemo }
